export default "__VITE_ASSET__Bcin8jib__"